import axios from 'axios';
import { DEV_MODE } from './dev/devMode';
const instance = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_ACTV8_API_ROOT_PROD : process.env.REACT_APP_ACTV8_API_ROOT_DEV, 
    headers: {
        common: {
            'x-api-key': process.env.NODE_ENV === 'production' ? process.env.REACT_APP_ACTV8_API_KEY_PROD : process.env.REACT_APP_ACTV8_API_KEY_DEV,
            'x-api-version': process.env.NODE_ENV === 'production' ? process.env.REACT_APP_ACTV8_API_VERSION_PROD : process.env.REACT_APP_ACTV8_API_VERSION_DEV,
            'Content-Type': 'application/json',
        }
    },
    timeout : process.env.REACT_APP_AXIOS_TIMEOUT_VALUE?? 10000
});

instance.interceptors.request.use(request => {
    return request;
});

// Warm the TLS connection to the API origin as early as the bundle executes —
// the first real call (GET /shortlink) then skips DNS/TCP/TLS setup. The origin
// is env-resolved, so this can't live statically in index.html.
try {
    const apiOrigin = new URL(instance.defaults.baseURL).origin;
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = apiOrigin;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
} catch (e) { /* malformed/missing base URL — preconnect is best-effort */ }

// Mock API: activates when the page URL uses a sample short-link slug
// (?sl=sample-offer etc., legacy mock- alias) or a pretty sample route
// (/sample-offer). Installed for plain `npm start` (NODE_ENV development),
// on the `/dev` + `/admin` builder routes, AND on /sample-* paths — so sample
// content is previewable even on a deployed staging build, where NODE_ENV is
// 'production'. Sample mode never writes to the real backend (the adapter
// intercepts every call).
const SAMPLE_ROUTE = /^\/sample-[a-z]+$/.test(window.location.pathname);
if (process.env.NODE_ENV === 'development' || DEV_MODE || SAMPLE_ROUTE) {
    require('./dev/mockApi').installMockApiIfRequested(instance);
}

export default instance;